import { render } from "./gammeTemplate.vue?vue&type=template&id=19955a06&scoped=true"
import script from "./gammeTemplate.vue?vue&type=script&lang=js"
export * from "./gammeTemplate.vue?vue&type=script&lang=js"

import "./gammeTemplate.vue?vue&type=style&index=0&id=19955a06&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19955a06"]])

export default __exports__